import * as React from "react";
import type { SVGProps } from "react";
const SvgSteeringWheel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm-1-2.062C7.06 19.444 4 16.07 4 12c0-.244.011-.486.033-.725l5.07 1.502A3.023 3.023 0 0 0 11 14.827v5.11ZM12 4C8.528 4 5.565 6.225 4.461 9.323l4.814 1.426A3.01 3.01 0 0 1 12 9c1.2 0 2.243.715 2.721 1.74l4.815-1.426C18.429 6.22 15.468 4 12 4Zm7.966 7.265L14.9 12.766a3.023 3.023 0 0 1-1.9 2.062v5.11c3.94-.494 7-3.867 7-7.938 0-.248-.011-.493-.034-.735ZM13 11.95A1.003 1.003 0 0 1 12 13c-.531 0-.97-.42-.998-.945a.98.98 0 0 0 0-.11c.028-.524.466-.945.998-.945.533 0 .973.423.999.95Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSteeringWheel;
